import endCategories from './apps/EndCategories';
import categoryMatching from './apps/CategoryMatching';


endCategories();
categoryMatching();





// WEBPACK FOOTER //
// ./frontend/index.js